<mat-card
  [ngClass]="{ 'is-important': news.isImportant, 'is-unread': !news.read }"
  (click)="!news.read && markAsRead(news)">
  <div class="card-header">
    <div class="title">{{ news.title }}</div>
    <div class="date">{{ news.date | safeDate: "shortDate" }}</div>
    @if (!news.read) {
      <div class="read-dot"></div>
    }
  </div>

  @if (isExpanded) {
    @if (content) {
      <div class="content" [innerHTML]="content | safeHTML"></div>
    } @else {
      <div class="spinner-container">
        <mat-spinner></mat-spinner>
      </div>
    }
  }

  <div class="footer">
    {{ news.isImportant ? "Important" : "Normal" }}
    @if (isExpanded) {
      <button mat-button class="basic-button" (click)="reduce()">
        {{ "actions.reduce" | translate }}
      </button>
    } @else {
      <button mat-button class="basic-button" (click)="expand()">
        {{ "actions.expand" | translate }}
      </button>
    }
  </div>
</mat-card>
